module.exports = __webpack_public_path__ + "abaca1b129edd4bb5cc36b56bf5ccea0.MP3";